if ($(".ordering-process").length) {
  function newFooter() {
    if ($(".id--9").length) {
      if ($(".cart-empty").length) {
        emptyCart();
      }
      document.addEventListener("ShoptetDOMContentLoaded", function () {
        if ($(".cart-empty").length) {
          emptyCart();
        }
      });
      dataHandle();
      function dataHandle() {
        let maxDeliveryDate = null;
        //console.log("test");
        $("tr.removeable").each(function () {
          $(this)
            .find(".availability-amount")
            .each(function () {
              const $amount = $(this);
              $amount.attr("style", $(this).prev(".availability-label").attr("style"));
              // console.log($amount);
              const availabilityCartText = $(this).prev(".availability-label").text().trim().toLowerCase();
              const deliveryCartDate = getDeliveryDateByAvailability(availabilityCartText);

              if (!deliveryCartDate) return;

              // 👉 uložíme nejvyšší datum
              if (!maxDeliveryDate || deliveryCartDate > maxDeliveryDate) {
                maxDeliveryDate = deliveryCartDate;
              }
              const formattedCartDate = formatDeliveryDate(deliveryCartDate);
            });
        });
        if (maxDeliveryDate) {
          const formattedMaxDate = maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";
          localStorage.setItem("maxDeliveryDate", formattedMaxDate);
        }
      }
    }
  }

  $(document).ready(function () {
    loadFooter(newFooter);
  });
}

if ($(".id--17").length) {
  $('input[name="vatId"]').removeAttr("placeholder");
  var $checkoutInputs = $('.id--17 input[type="text"], .id--17 input[type="email"], .id--17 input[type="password"], .id--17 input[type="tel"]');
  $checkoutInputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  $checkoutInputs.on("click focus", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  $checkoutInputs.on("blur", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $(".co-contact-information").prepend(`
            <div class="customLogin">
                    <p>Máte u nás účet? Přihlaste se, údaje se vyplní automaticky.
                  <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);
  }
}

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));
}

if ($(".id--15").length) {

  $("h1").text("Objednávka přijata");
  $("h1").after("<p>Děkujeme za objednávku.</p>");
  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith("Číslo objednávky ");

  $('.recapitulation-wrapper[data-testid="recapTable"]').append('<div class="co-box co-extra"></div>');
  $(".co-box.co-extra").append($('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])'));
  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);
    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");
      $row.append('<td class="zdarma"><span>Zdarma</span></td>');
      $row.find("strong.for-free").text("Dárek k objednávce");
      console.log("true");
    }
    const $cell = $row.find("td.p-quantity");
    if (!$cell.length) return;

    const total = parseFloat($cell.find("strong").text().replace(/\s/g, "").replace("Kč", "").replace(",", "."));
    $row.append(`<td class="pricePerSingle"><span>${total} / ks</span></td>`);
  });
}
/*
if ($(".id--16").length) {
  const maxDate = localStorage.getItem("maxDeliveryDate");
  if (maxDate) {
    function renderMaxDeliveryDate() {
      $(".order-delivery-payment-form #order-shipping-methods .payment-shipping-price").each(function () {
        const $price = $(this);

        const $paymentInfo = $price.closest("label").find(".payment-info").first();
        $paymentInfo.find(".customDateDelivery").remove();
        if ($paymentInfo.length) {
          $paymentInfo.append(`<span class="customDateDelivery">Doručíme do ${maxDate}</span>`);
        }
      });
    }

    renderMaxDeliveryDate();
    document.addEventListener("ShoptetDOMCartContentLoaded", renderMaxDeliveryDate);
  }


}
*/
function mhProductInfoMove() {
  if ($(".id--9").length) {
    $(".availability-label").each(function () {
      const availabilityText = $(this).text().trim().toLowerCase();
      if (availabilityText.includes("skladem")) {
        $(this).css("color", "#1A9E4A");
      }
    });

    if ($(".extra.delivery span .price-range").length) {
      $(".extra.delivery").append($(".extra.delivery span .price-range").clone());
    }
    let maxDeliveryDate = null;

    function updateMaxDeliveryDateFromAvailability($availabilitySource) {
      if (typeof getDeliveryDateByAvailability !== "function") {
        return;
      }

      const availabilityText = ($availabilitySource.text() || "").replace(/\s+/g, " ").trim();
      if (!availabilityText) {
        return;
      }

      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (!deliveryDate) {
        return;
      }

      if (!maxDeliveryDate || deliveryDate > maxDeliveryDate) {
        maxDeliveryDate = deliveryDate;
      }
    }

    $("tr.removeable").each(function () {
      const $availability = $(this).find(".p-availability");
      $(this).find(".p-name").append($availability.clone());
      $(this).find(".p-total").append($(this).find(".p-price").clone());

      const $availabilityLabel = $availability.find(".availability-label").first();
      updateMaxDeliveryDateFromAvailability($availabilityLabel.length ? $availabilityLabel : $availability);
    });

    // 👉 po dokončení loopu uložíme datum
    if (maxDeliveryDate) {
      const formattedMaxDate = maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";

      localStorage.setItem("maxDeliveryDate", formattedMaxDate);

      console.log("Max delivery date:", formattedMaxDate);
    } else {
      localStorage.removeItem("maxDeliveryDate");
    }



    $(".summary-wrapper").prepend('<div class="customBox"></div>');
    $(".summary-wrapper .customBox").append($(".next-step-back").clone());



    $(".customBox").append(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                Mám slevový kód
            </label>
        `);
    $(".summary-wrapper .customBox").append($(".cart-summary .discount-coupon").clone());
    $(".summary-wrapper .customBox").append($(".cart-summary .extra.delivery").clone());

    $("#discount-checkbox").on("change", function () {
      $(".discount-coupon").toggleClass("active", this.checked);
    });

    if ($(".delivery-time").length) {
      $(".customBox").append($(".delivery-time"));
    }
    if ($(".discount-coupon .applied-coupon").length) {
      $(".discount-coupon").addClass("active");
      $("#discount-checkbox").prop("checked", true);
      $('input[data-testid="buttonRemoveDiscountCoupon"]').attr("value", "Odstranit slevový kód");
    }
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za m. j.</th>
                <th class="sale">Sleva</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $("tr.removeable").each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find(".p-price .show-tooltip").attr("title") || $row.find(".p-price .show-tooltip").attr("data-original-title");
          console.log();
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(",", "."))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, "")) : 0;
          const finalPrice = parseInt($row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, ""));
          const quantity = parseInt($row.find("input.amount").val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find(".p-price").append(`
                    <span class="sale-percent">${percent}%</span>
                `);
          $row.find(".p-total").before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      } else {
        $row.find(".p-total").before('<td class="p-sale"></td>');
      }
    });

    if (totalSaved > 0) {
      $(".price-wrapper").append(`
            <span class="price-label price-secondary" style="color:#118819;">
            Ušetřili jste:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }
  } else {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za mj.</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
  }

  $(".summary-wrapper .customBox").append($(".cart-summary .extra.delivery").clone());

  if ($(".delivery-time").length) {
    $(".customBox").append($(".delivery-time"));
  }
}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  mhProductInfoMove();
});

function emptyCart() {
  $("h1:not(.sr-only), .h1:not(.sr-only)").after($("#footer .emptyCartText"));
}

$("html").on("click", ".customLoginPopup", function (e) {
  e.preventDefault();
  e.stopPropagation();

  $("body").addClass("user-action-visible login-window-visible");
});

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
   $('.extras-wrap .extra.discount span').html(velkoText)
  // admin varianta popupu (přesun slevy do tlačítek) je v _advancedOrder.js
});
